document.addEventListener("DOMContentLoaded", () => {
  /* DISABLE console.log */
  // console.log = function() {}
  
  /* BOGOS */
  setTimeout(() => {
    const text = "ADD Holiday Journey Pack at 70% OFF";
    // changeBOGOSButtonText(text.toUpperCase());
  }, 1000);
});

const changeBOGOSButtonText = (buttonText = "ADD WITH 70% OFF") => {
  const fgButtonEl = document.querySelector(".btn-add-to-cart");
  fgButtonEl.innerHTML = buttonText;
  console.log("FG BUTTON", fgButtonEl);
}